import { DeepReadonly, TagType } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const nonRemovableTagTypes: DeepReadonly<Array<TagType>> = deepFreeze([
  TagType.OVER_12_MONTHS_UK,
  TagType.UNDER_12_MONTHS_UK,
  TagType.PATHWAY,
  TagType.EUSS_GRANTED,
  TagType.EUSS_PENDING,
  TagType.MULTI_INTAKE,
  TagType.MANUAL_CAS,
]);

export const systemTagTypes: DeepReadonly<Array<TagType>> = deepFreeze([
  TagType.PATHWAY,
  TagType.EUSS_GRANTED,
  TagType.EUSS_PENDING,
  TagType.MULTI_INTAKE,
  TagType.MANUAL_CAS,
  TagType.TRANSFERMATE,
  TagType.OVER_12_MONTHS_UK,
  TagType.UNDER_12_MONTHS_UK,
  TagType.OVER_28_DAYS_VISA_GAP,
  TagType.UNDER_28_DAYS_VISA_GAP,
]);
